import * as React from "react";
import { ButtonType, CustomButton, SortableTableHeader, Table } from "soprasteria-ui-library";
import { formatDate } from "../../../../../helpers/DateHelper";
import { ICarePerformer, ICarePerformerListItem } from "../../../../../models/ICarePerformer";
import { useAuth } from "../../../../../App";
import { CarePerformerApi } from "../../../../../api/CarePerformerApi";
import { CarePerformerModal } from "../../../../CarePerformerModal/CarePerformerModal";
import { UserContext, isInRole } from "../../../../../contexts/UserContext";
import { MENUETTPORTALMA, MENUETTPORTALVA } from "../../../../../utils/RoleConstants";

interface IProps {
    carePerformers: ICarePerformerListItem[];
    clinicId: number;
    onSuccess: (message: string) => void;
}

export const CarePerformerTable: React.FC<IProps> = ({ carePerformers, clinicId, onSuccess }) => {
    const auth = useAuth();
    const api = new CarePerformerApi(auth);
    const abortController = new AbortController();
    const [renderModal, setRenderModal] = React.useState<boolean>(false);
    const [carePerformer, setCarePerformer] = React.useState<ICarePerformer>();
    const userInfo = React.useContext(UserContext);
    const hasRoleVA = isInRole(MENUETTPORTALVA, userInfo.roles ? userInfo.roles : []);
    const hasRoleMA = isInRole(MENUETTPORTALMA, userInfo.roles ? userInfo.roles : []);

    React.useEffect(() => {
        if (carePerformer) {
            document.getElementById("open-care-performer-modal")?.click();
            setRenderModal(true);
        }

        return () => {
            abortController.abort();
        }
    }, [carePerformer]);

    const closeModal = () => {
        setRenderModal(false);
        setCarePerformer(undefined);
    }

    const onSubmit = (submitMessage: string) => {
        document.getElementById("close-care-performer-modal")?.click();
        onSuccess(submitMessage);
    }

    const handleRowClick = (carePerformerId: number) => {
        loadCarePerformer(carePerformerId);
    }

    const loadCarePerformer = (carePerformerId: number) => {
        api.getCarePerformerById(carePerformerId, (data) => {
            setCarePerformer(data);
        }, undefined, undefined);
    }

    return (
        <>
            <section>
                <div className="panel text-right">
                    <CustomButton buttonText="Lägg till behandlare" buttonType={ButtonType.create} data-toggle="modal" data-target="#open-care-performer-modal" onClick={() => setRenderModal(true)} />
                </div>
                <Table hoverableRows>
                    <thead>
                        <tr>
                            <SortableTableHeader propertyToSortBy="UserFullName" headerText="Användare (Person)" />
                            <SortableTableHeader propertyToSortBy="UserHsaId" headerText="HSA-ID Användare" />
                            <SortableTableHeader propertyToSortBy="CareLicenseTypeName" headerText="Legitimation" />
                            <SortableTableHeader propertyToSortBy="DateFrom" headerText="Fr.o.m." />
                            <SortableTableHeader propertyToSortBy="DateTo" headerText="T.o.m." />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            carePerformers && carePerformers.length > 0
                                ? carePerformers.map((carePerformer, key) => {
                                    return (
                                        <tr key={key} className="clickable-row" onClick={() => handleRowClick(carePerformer.carePerformerId)}>
                                            <td>{carePerformer.userFullName}</td>
                                            <td>{carePerformer.userHsaId}</td>
                                            <td>{carePerformer.careLicenseTypeName}</td>
                                            <td>{formatDate(carePerformer.dateFrom)}</td>
                                            <td>{formatDate(carePerformer.dateTo, "Tillsvidare")}</td>
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan={5}>Det finns inga behandlare på denna mottagning</td></tr>
                        }
                    </tbody>
                </Table>
            </section>
            {
                renderModal ?
                    <CarePerformerModal carePerformer={carePerformer} clinicId={clinicId} closeModal={closeModal} onSubmit={onSubmit} />
                    : null
            }
        </>
    )
}